import { render } from "./FieldLinearScale.vue?vue&type=template&id=229938b0&scoped=true"
import script from "./FieldLinearScale.vue?vue&type=script&lang=js"
export * from "./FieldLinearScale.vue?vue&type=script&lang=js"

import "./FieldLinearScale.vue?vue&type=style&index=0&id=229938b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229938b0"]])

export default __exports__